import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector, batch } from "react-redux";
import { useParams } from "react-router-dom";

import { useUser } from "../../../../context/UserContext";
import { fetchOpportunitiesRequest } from "../../../../store/features/actions/opportunities/opportunitesActions";
import { fetchWinOpportunitiesRequest } from "../../../../store/features/actions/opportunities/winOpportunitiesActions";
import { fetchConvertToWinRequest } from "../../../../store/features/actions/opportunities/convertToWinAction";

import OpportunityFilterContainer from "./opportunityFilterContainer/OpportunityFilterContainer";
import GenericTable from "../../genericComponents/genericTableComp/GenericTable";
import TagList from "../../genericComponents/tag/TagList";
import IOSSpinner from "../../../HtmlElements/IOSSpinner";
import ScHeaderComp from "../../genericComponents/genericTableComp/genericTableScHeader/ScHeaderComp";
import TagOverflowHandler from "../../uiUtils/TagOverflowHandler";

// import BattleCard from "./CardTabs/BattleCard";
import ContactMapCard from "./CardTabs/ContactMapCard";
import BusinessCaseCard from "./CardTabs/BusinessCaseCard";
import Templates from "./CardTabs/Templates";
import News from "./CardTabs/News";
import ValueSellingPrompter from "./CardTabs/ValueSellingFramework";
import NextSteps from "./CardTabs/NextSteps";

import "./SpotOpportunities.css";
import { deleteOpportunity, fetchConvertToWin, markReadByUser } from "../../../../services/iqApiV2";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import MemoryContainerSC from "../../../Navigation/memoryComps/MemoryContainerSC";
import ClosureCard from "./CardTabs/ClosureCard";
import { useBanner } from "../../../../context/BannerContext";
import PitchCard from "./CardTabs/PitchCard";
import TR3DotMenu from "../../genericComponents/genericTableComp/TR3DotMenu";
import SimpleSearchBar from "../../genericComponents/simpleSearchBar/SimpleSearchBar";
import StatusIndicator from "../../genericComponents/resizeableTable/StatusIndicator";
import { useGroupTaskWebSocket } from "../../../../context/GroupTaskWebSocketContext";
import BattleCardV2 from "./CardTabs/BattleCardV2";

const iconSVG = (
  <svg xmlns="http://www.w3.org/2000/svg" className="top_tab_icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#535458" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
);

function WinOpportunities() {
  const dispatch = useDispatch();
  const [tabData, setTabData] = useState([]);
  const { clientName, accountName } = useParams();
  const { user } = useUser();
  const { opportunitesData, opportunitesLoading } = useSelector(state => state.opportunitiesReducer);
  const { winOpportunitesData, winOpportunitesLoading } = useSelector(state => state.winOpportunitiesReducer);
  const [searchQuery, setSearchQuery] = useState(""); // Search input state
  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState([]);
  const [activeTab, setActiveTab] = useState("battle_card_wo");
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [currRow, setCurrRow] = useState();
  const [selectedOpportunity, setSelectedOpportunity] = useState({ id: null, name: null, desc: null ,mainSignal:null,relevanceScore:null});
  const [showMemSc,setShowMemSc]= useState(false);
  const {getDataById } = useGroupTaskWebSocket();
  const commonProps = useMemo(() => ({
    opportunityId: selectedOpportunity.id,
    opportunityName: selectedOpportunity.name,
    opportunityDescription: selectedOpportunity.desc,
    mainSignal:selectedOpportunity.mainSignal,
    relevanceScore:selectedOpportunity.relevanceScore
  }), [selectedOpportunity]);
  const showBanner = useBanner()
  const tabConfig = useMemo(() => [
    { key: "battle_card_wo",tabId:"battle_card", label: "Battle Card", Component: () => <BattleCardV2  {...commonProps}/>, icon: iconSVG , tagIcon:<img src="/img/blueDocIcon.png" width="16"/>},
    { key: "contact_map_wo",tabId:"contact_map", label: "Contact Map", Component: () => <ContactMapCard {...commonProps} />, icon: iconSVG, tagIcon:<img src="/img/blueDocIcon.png" width="16"/> },
    { key: "business_case_wo",tabId:"business_case", label: "Business Case", Component: () => <BusinessCaseCard {...commonProps} />, icon: iconSVG, tagIcon:<img src="/img/blueDocIcon.png" width="16"/> },
    // { key: "templates_wo",tabId:"templates", label: "Templates", Component: () => <Templates {...commonProps} />, icon: iconSVG, tagIcon:<img src="/img/redDocIcon.png" width="16" /> },
    { key: "news_wo",tabId:"news", label: "News", Component: () => <News {...commonProps} />, icon: iconSVG, tagIcon:<img src="/img/redDocIcon.png" width="16" /> },
    { key: "prompter_wo",tabId:"value_selling_prompter", label: "Prompter", Component: () => <ValueSellingPrompter {...commonProps} />, icon: iconSVG , tagIcon:<img src="/img/redDocIcon.png" width="16" />},
    { key: "next_step_wo",tabId:"next_step", label: "Next Step", Component: () => <NextSteps {...commonProps} />, icon: iconSVG, tagIcon:<img src="/img/redDocIcon.png" width="16" /> },
    { key: "pitch_card_wo",tabId:"generate_pitch", label: "Pitch", Component: () => <PitchCard {...commonProps} />, icon: iconSVG, tagIcon:<img src="/img/redDocIcon.png" width="16" /> },
    { key: "closure_note_wo",tabId:"closure_note", label: "Closure Note", Component: () => <ClosureCard {...commonProps} />, icon: iconSVG, tagIcon:<img src="/img/redDocIcon.png" width="16" /> },
  ], [commonProps]);
  const liveOpps = getDataById("win_opp_table")
  const handleSideCard = useCallback(
  async (e, item, tabId) => {
    console.log("win_opp_table", item);
    e.preventDefault();
    e.stopPropagation();

    setShowMoreModal(true);
    setSelectedOpportunity({
      id: item._id,
      name: item.opportunity_name,
      desc: item.opportunity_description,
      mainSignal: item.tag,
      relevanceScore: item.relevance_score
    });
    setCurrRow(item);
    setActiveTab(tabId || "battle_card_wo");

    try {
      if (item?.is_read === false) {
        const resp = await markReadByUser(user?.id, item?._id);
        if (resp) {
          dispatch(fetchWinOpportunitiesRequest({
            clientName,
            accountName,
            userId: user?.id,
            type: "win"
          }));
        }
      }
    } catch (err) {
      console.error("Failed to mark as read:", err);
    }
  },
  [user, clientName, accountName, dispatch]
);


    const handleDeleteOpp = useCallback(async (e, userId, item) => {
      e.preventDefault();
      e.stopPropagation();
      const resp=  await deleteOpportunity(userId, item?._id); // Pass params if needed
      if (resp) {
        showBanner({ message: 'Deleted From Win Opportunities',title:"Alert", type: 'success', duration: 5000 })
        dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId:userId, type: "spot" }));
        dispatch(fetchWinOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "win" }))
      }
    }, []);

    

useEffect(() => {
  if (!winOpportunitesData) return;

  let filteredData = winOpportunitesData;

  // Apply search filter
  if (searchQuery) {
    const query = searchQuery.toLowerCase();
    filteredData = filteredData.filter(item =>
      item.opportunity_name?.toLowerCase().includes(query) ||
      item.tag?.toLowerCase().includes(query) ||
      item.relevance_score?.toLowerCase().includes(query)
    );
  }

  // Apply filters
  filteredData = filteredData.filter(item =>
    Object.entries(filters).every(([key, values]) =>
      !values.length || values.includes(item[key.toLowerCase()] || item[key])
    )
  );

  // Map data with enhanced UI components
  const transformedData = filteredData.map(item => ({
    ...item,
    opportunity_name: (
      <div className="win-opp-name-detal" onClick={(e) => handleSideCard(e, item)}>
        <div className="gtr-cell-content">{item?.opportunity_name}</div>
        <div className="win-opp-name-detal-xtra">
          <div className="opp-user-icon-container">
            <img src="/img/users.png" alt="users" className="mr-1" /> {item.contact_count}
          </div>
          <div className="win-opp-name-detal-xtra-divider" />
          {item.relevance_score}%
        </div>
      </div>
    ),
    tag: (
      <div onClick={(e) => handleSideCard(e, item)}>
        <TagList tags={item.tag} />
      </div>
    ),
    documents: (
      <div style={{width:"100%"}}> <TagOverflowHandler handleSideCard={handleSideCard} tabConfig={tabConfig} rowData={item} /></div>
      
    ),
    saveFav: (
      <TR3DotMenu
        menuItems={[
          { label: "Delete", onMenuClick: (e) => handleDeleteOpp(e, user?.id, item) }
        ]}
      />
    )
  }));

  setTabData(transformedData);
}, [winOpportunitesData, searchQuery, filters, handleSideCard, tabConfig]);

  console.log("liveOpps in win",liveOpps)
  useEffect(() => {

    const hasPending = liveOpps.some((element) => element.status === "pending");

    setTabData((prev) => {
      // Remove any existing isPartialLoad rows first
      const cleaned = prev?.filter((item) => !item?.isPartialLoad) || [];

      if (hasPending) {
        // Add isPartialLoad at the top
        return [
          {
            isPartialLoad: (
              <td colSpan={7} className="gtr-expanded-cell">
                <StatusIndicator text="Adding new Opportunities" />
              </td>
            ),
          },
          ...cleaned,
        ];
      } else {
        return cleaned;
      }
    });

        liveOpps.forEach((item,idx)=>{
          if (item?.status == "completed") {
            console.log("called spot through live ",idx)
            setTimeout(() => {
                 dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "win" }));
            }, 1000);
                 
          }
    
        })
  }, [liveOpps?.length]);

  const appliedFiltersCount = useMemo(() =>
    Object.values(filters).reduce((acc, val) => acc + (val.length || 0), 0), [filters]);

  const tableColumns = useMemo(() => [
    { id: "opportunity_name", label: "Opportunity", width: 100 },
    { id: "tag", label: "Signal", width: 90 },
    { id: "documents", label: "Opportunity Win Kit", width: 250 },
    { id: "saveFav", label: "", width: 10, clickAction: true },
  ], []);

  const onApply = async( ids) => {
          const resp = await fetchConvertToWin(ids, user?.id,()=>{ 
          dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user?.id, type: "spot" }));
          dispatch(fetchWinOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "win" }));});
          if (resp) {
            setFilters({})
            showBanner({ message: 'Moved To Win Opportunities',title:"Alert", type: 'info', duration: 2000 })
          }
  };

  useEffect(() => {
    if (clientName && accountName && user?.id) {
      dispatch(fetchWinOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "win" }));
      dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "spot" }));
    }
  }, [clientName, accountName, user?.id]);

  useEffect(() => {
    if (opportunitesData?.length) {
      setFilterOptions(opportunitesData);
    }
  }, [opportunitesData]);

  return (
    <>
      <OpportunityFilterContainer
        filterTxt="Select Opportunities"
        filterOptions={filterOptions}
        filters={filters}
        setFilters={setFilters}
        notSingleton={false}
        onApply={onApply}
        loading={opportunitesLoading}
        type="win"
        mainTitl="Close deals faster with your Opportunity win kit"
        filterTitl="Pick from Spot Opportunities to generate kit"
        oppBtnTitl="Or Add your existing Opportunity to generate kit"
      />

      <div className="find-opportunities-container mounted">
      <span className="find-opportunities-header-container">
        <span style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginBottom:'0px' }}>
          <h6 className="find-opportunities-results-title">
            Showing {winOpportunitesLoading || opportunitesLoading ? <IOSSpinner /> : tabData.length} Results
          </h6>
          {appliedFiltersCount > 0 && (
            <div className="find-opportunities-results-title-filter-badge">
              {appliedFiltersCount} filters applied
              <img src="/img/x.png" alt="clear" onClick={() => setFilters({})} />
            </div>
          )}
          
        </span>
        {/* <button
          className="memory_btn_trans"
          onClick={(e) =>{ 
                setShowMemSc((prev) => !prev)
                 dispatch(listGlobalMemRequest({userId:user?.id,memoryType:"opportunity"}))
              }} 
        >
          
          <img src="/img/plus1.png" className="memory_icon" />
          Memory
        </button> */}
         <SimpleSearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        </span>

        <div className="find-opportunities-results-container">
          <GenericTable
            initialColumns={tableColumns}
            tabData={tabData}
            sideCardTabConfig={tabConfig}
            showMoreModal={showMoreModal}
            setShowMoreModal={setShowMoreModal}
            loading={(winOpportunitesLoading || opportunitesLoading) && winOpportunitesData?.length==0}
            titleForSideCard={
              <ScHeaderComp 
                key={`side_card_head_comp_${commonProps?.opportunityId}`} 
                type="win_opportunities" 
                data={currRow} 
                setShowMoreModal={setShowMoreModal} 
                opportunityId={commonProps?.opportunityId} 
                tabConfig={tabConfig} 
                showMoreModal={showMoreModal} 
                showMemComp={true} 
                memoryType={"single-opportunity"}
              />
              }
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>
      </div>


      <GenericOverviewSideCard
        showMoreModal={showMemSc}
        setShowMoreModal={setShowMemSc}
        titleForSideCard={<div className='mem-sc-titl-cont'><img className='back-btn-img' src="/img/backArrow.png" onClick={()=>setShowMoreModal(false)}/> <span className="span_memory">Memory</span></div>}
        comp={<MemoryContainerSC memoryType="opportunity"/>}
        minWidthForDrawer="30%"
        disableXbtn
        />
    </>
  );
}

export default WinOpportunities;